import { Dropdown } from 'react-bootstrap';
import { ButtonDefinition, TopbarDropdownNavItem } from './TopbarButton';
import { MenuButtonToggle, MenuCloseToggle } from './TopbarToggles';
import styles from './Topbar.module.scss';

/** Mostra il menu a tendina compatto usato sotto il breakpoint desktop. */
const TopbarMobileMenu = ({ isLoggedIn, isNative, buttons, pagePath }: { isLoggedIn: boolean; isNative: boolean; buttons: ButtonDefinition[]; pagePath: string }) => {
  if (!isLoggedIn || isNative) return null;

  return (
    <Dropdown className={`d-inline-block d-lg-none mr-2 ${styles.mobileMenu}`}>
      <Dropdown.Toggle as={MenuButtonToggle} />
      <Dropdown.Menu className={styles.mobileMenuPanel}>
        <div className={styles.mobileMenuHeader}>
          <span>Menu</span>
          <Dropdown.Toggle as={MenuCloseToggle} />
        </div>
        <div className={styles.mobileMenuItems}>
          {buttons.map((button, i) => {
            const element = (
              <TopbarDropdownNavItem
                key={i.toString()}
                pagePath={pagePath}
                url={button.url}
                label={button.label}
                onClick={button.onClick}
                button={button}
              />
            );
            if (!button.condition || button.condition()) return element;
            return null;
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export { TopbarMobileMenu };
